







import { Component, Prop } from 'vue-property-decorator';
import { AgencyStatus, IAgency } from 'admiral-core';
import 'dayjs/locale/de';
import { mixins } from 'vue-class-component';
import { Util } from '@/utils/Util';
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { FormatMixin } from '@/mixins/FormatMixin';

dayjs.extend(quarterOfYear);
@Component({
  name: 'agency-status-badge',
  components: {},
})
export default class AgencyStatusBadge extends mixins(FormatMixin) {
  @Prop({ type: Object, required: true })
  agency!: IAgency;

  formatAgencyStatus(agencyStatus: AgencyStatus) {
    return Util.formatAgencyStatus(agencyStatus);
  }

  get endsAt() {
    return Util.formatAgencyStatusEndsAtStr(this.agency);
  }
}
